"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Subject = exports.LocalStorageStore = exports.NoopStore = exports.Config = exports.ConsentManagerImpl = void 0;
var consent_manager_impl_1 = require("./consent-manager-impl");
Object.defineProperty(exports, "ConsentManagerImpl", {
  enumerable: true,
  get: function () {
    return consent_manager_impl_1.ConsentManagerImpl;
  }
});
var config_1 = require("./config");
Object.defineProperty(exports, "Config", {
  enumerable: true,
  get: function () {
    return config_1.Config;
  }
});
var noop_store_1 = require("../lib/store/noop-store");
Object.defineProperty(exports, "NoopStore", {
  enumerable: true,
  get: function () {
    return noop_store_1.NoopStore;
  }
});
var localstorage_store_1 = require("../lib/store/localstorage-store");
Object.defineProperty(exports, "LocalStorageStore", {
  enumerable: true,
  get: function () {
    return localstorage_store_1.LocalStorageStore;
  }
});
var observable_1 = require("../lib/observable/observable");
Object.defineProperty(exports, "Subject", {
  enumerable: true,
  get: function () {
    return observable_1.Subject;
  }
});